<div class="app-section-header">
  <div class="app-section-header-item app-category-container">
    <div class="app-section-header-category" routerLinkActive="active">
      <a routerLink="/users/list">Users</a>
    </div>
    <div class="app-section-header-category" routerLinkActive="active">
      <a routerLink="/users/groups">Groups</a>
    </div>
  </div>
</div>
